import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import cx from 'classnames';
import {
    Grid,
    Row,
    Col
} from 'react-bootstrap';
import s from './Security.css';
import cs from '../../commonStyle.css';
import Icon1 from '/public/SiteIcons/securityIcon1.svg';
import Icon2 from '/public/SiteIcons/securityIcon2.svg';
import Icon3 from '/public/SiteIcons/securityIcon3.svg';

// Translation
import { FormattedMessage } from 'react-intl';
import messages from '../../../locale/messages';

class Security extends Component {
    render() {
        const { data } = this.props;

        return (
            <div className={s.securityBlock}>
                <div className={s.container}>
                    <div className={s.securityContent}>
                        <h2 className={s.securityTitle}>You Are Protected</h2>
                        <p className={s.securityDesc}>We understand that your car is an important investment, and we’re committed to keeping it safe:</p>
                    </div>
                    <Row className={s.securityRow}>
                        <Col lg={4} md={4} sm={4} xs={12}>
                            <div className={s.securityItem}>
                                <div className={s.securityItemImage}><img src={Icon1} /></div>
                                <h4>AI-Powered Inspections</h4>
                                <p>Our advanced AI technology ensures that every rental is safe and secure by conducting thorough inspections before and after each trip.</p>
                            </div>
                        </Col>
                        <Col lg={4} md={4} sm={4} xs={12}>
                            <div className={s.securityItem}>
                                <div className={s.securityItemImage}><img src={Icon2} /></div>
                                <h4>User Verification</h4>
                                <p>We verify the identity of all renters on our platform, creating a trusted environment where you can feel confident in sharing your car.</p>
                            </div>
                        </Col>
                        <Col lg={4} md={4} sm={4} xs={12}>
                            <div className={s.securityItem}>
                                <div className={s.securityItemImage}><img src={Icon3} /></div>
                                <h4>Optional Insurance Coverage</h4>
                                <p>We’ve partnered with a reliable third-party provider to offer excess insurance coverage for an additional fee. This optional insurance gives you extra protection, without any liability on MotoStream’s part</p>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }
}

export default withStyles(s, cs)(Security); 